import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import ExternalSupplierAware from 'src/app/model/helper-interfaces/external-supplier-aware';
import Employee from 'src/app/model/product/employee';

// TODO use this component wherever external supplier fields can be edited
@Component({
  selector: 'external-supplier',
  templateUrl: './external-supplier.component.html',
  styleUrls: ['./external-supplier.component.scss']
})
export class ExternalSupplierComponent {
  @Input()
  externalSupplierAware: ExternalSupplierAware;

  @Input()
  employeeChoices: Employee[] = [];

  @Output()
  save = new EventEmitter<any>();

  extraHoogwerkerChange(event): void {
    this.externalSupplierAware.extraHoogwerker = event;
    this.save.emit();
  }

  extraHoogwerkerTextChange(event): void {
    this.externalSupplierAware.extraHoogwerkerDescription = event;
    this.save.emit();
  }

  extraHoogwerkerDoneChange(event): void {
    this.externalSupplierAware.extraHoogwerkerDone = event;
    this.save.emit();
  }

  extraHoogwerkerEmployeeChange(): void {
    this.save.emit();
  }

  extraHoogwerkerDeadlineChange(event): void {
    this.externalSupplierAware.extraHoogwerkerDeadline = event.value;
    this.save.emit();
  }

  parkingBanChange(value): void {
    this.externalSupplierAware.parkingBan = value;
    this.save.emit();
  }

  extraInfoParkingBanChange(value): void {
    this.externalSupplierAware.extraInfoParkingBan = value;
    this.save.emit();
  }

  parkingBanDoneChange(value): void {
    this.externalSupplierAware.parkingBanDone = value;
    this.save.emit();
  }

  parkingBanEmployeeChange(): void {
    this.save.emit();
  }

  parkingBanDeadlineChange(event): void {
    this.externalSupplierAware.parkingBanDeadline = event.value;
    this.save.emit();
  }

  needExtraSupplierChange(value): void {
    this.externalSupplierAware.needExtraSupplier = value;
    this.save.emit();
  }

  needExtraSupplierDoneChange(value): void {
    this.externalSupplierAware.needExtraSupplierDone = value;
    this.save.emit();
  }

  extraInfoNeedExtraSupplierChange(value): void {
    this.externalSupplierAware.extraInfoNeedExtraSupplier = value;
    this.save.emit();
  }

  extraSupplierEmployeeChange(): void {
    this.save.emit();
  }

  extraSupplierDeadlineChange(event): void {
    this.externalSupplierAware.extraSupplierDeadline = event.value;
    this.save.emit();
  }

  needExtraMaterialsChange(value): void {
    this.externalSupplierAware.needExtraMaterials = value;
    this.save.emit();
  }

  needExtraMaterialsDoneChange(value): void {
    this.externalSupplierAware.needExtraMaterialsDone = value;
    this.save.emit();
  }

  extraInfoNeedExtraMaterialsChange(value): void {
    this.externalSupplierAware.extraInfoNeedExtraMaterials = value;
    this.save.emit();
  }

  extraMaterialsEmployeeChange(): void {
    this.save.emit();
  }

  extraMaterialsDeadlineChange(event): void {
    this.externalSupplierAware.extraMaterialsDeadline = event.value;
    this.save.emit();
  }

  compareEntities(o1, o2): boolean {
    return GeneralHelper.compareEntities(o1, o2);
  }
}
